import {Action} from "react-fetching-library";
import {CommissionsSection} from "./CommissionsAction";
import {ServicesUrl} from "./paths";

export interface MagicUser {
    id: string;
    email: string;
    isuser: boolean;
    createdAt: string;
    modifiedAt: string;
    image?: string;
}

export interface CommentData {
    id: string;
    content: string;
    created: string;
    modified: string;
    magic_user: MagicUser;
}

export interface Blog {
    id: number;
    title: string;
    body: string;
    created: string;
    modified: string;
    comments?: CommentData[];
}

export const getBlogs  = () : Action<Blog[]> => ({
    method: 'GET',
    endpoint: `${ ServicesUrl.blog }/list2.json`,
})

export const getDetailBlogs  = (data:{id:string}) : Action<Blog> => ({
    method: 'GET',
    endpoint: `${ ServicesUrl.blog }/view_post/${ data.id }.json`,
})

export const getDetailBlogsComments  = (data:{id:string}) : Action<CommentData[]> => ({
    method: 'GET',
    endpoint: `${ ServicesUrl.blogComments }/get/${ data.id }.json`,
})

export const addDetailBlogsComments  = (data:{id:string, email:string, token:string, comment:string }) : Action<CommentData[]> => {
    const body = {
        User: {
            token: data.token,
            email: data.email
        },
        Comment: {
            content: data.comment
        }
    }
    return {
        method: 'POST',
        endpoint: `${ ServicesUrl.blogComments }/add/${ data.id }.json`,
        body: body,
    }
}